import { render } from "./LittlePerson.vue?vue&type=template&id=4a13d2db"
const script = {}
script.render = render

export default script